import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Button, ButtonToolbar } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { Dialog } from '@material-ui/core';

const DialogForFullScreenComponent = (props) => {
  const { t, message, color, title, toggleDialog, isOpen, btns } = props;

  let Icon;

  switch (color) {
    case 'primary':
      Icon = <span className="lnr lnr-pushpin modal__title-icon" />;
      break;
    case 'success':
      Icon = <span className="lnr lnr-thumbs-up modal__title-icon" />;
      break;
    case 'warning':
      Icon = <span className="lnr lnr-flag modal__title-icon" />;
      break;
    case 'danger':
      Icon = <span className="lnr lnr-cross-circle modal__title-icon" />;
      break;
    default:
      break;
  }

  return (
    <MuiThemeProvider>
      <Dialog
        className="m-2 align-items-end"
        style={{ bottom: 'auto' }}
        open={isOpen}
      >
        <div
          className={`modal-dialog--${color} modal-alert d-flex flex-column justify-content-center modal-dialog-fullscreen`}
        >
          <div className="modal__header d-flex flex-column align-items-center">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              onClick={toggleDialog}
            />
            {Icon}
            <h4 className="bold-text  modal__title">{t(title)}</h4>
          </div>
          <div className="modal__body text-center">{t(message)}</div>
          <ButtonToolbar className="modal__footer">
            {btns.map((btn) => (
              <Button key={btn.order} color={btn.color} onClick={btn.onClick}>
                {t(btn.message)}
              </Button>
            ))}
          </ButtonToolbar>
        </div>
      </Dialog>
    </MuiThemeProvider>
  );
};

DialogForFullScreenComponent.propTypes = {
  t: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.string,
  title: PropTypes.string,
  btns: PropTypes.arrayOf(
    PropTypes.shape({
      order: PropTypes.number.isRequired,
      color: PropTypes.string,
      onClick: PropTypes.func.isRequired,
      message: PropTypes.string.isRequired,
    })
  ).isRequired,
};

DialogForFullScreenComponent.defaultProps = {
  title: '',
  message: '',
};

export default withTranslation('common')(DialogForFullScreenComponent);
